// extracted by mini-css-extract-plugin
export default {"container":"A_container__CtdAd","darkmode":"A_darkmode__5mWLQ"};